module.exports = __webpack_public_path__ + "static/sf-talks-logo-4ba260b26c72fc417e41e8019017d88c.png";